import toastr from 'toastr';
import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslateService } from '@ngx-translate/core';

type ToastType = 'success' | 'warning' | 'error';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(
    private spinner: NgxSpinnerService,
    private translate: TranslateService) {
  }

  public success( message: string): boolean {
    this.spinner.hide();

    this.showToast( 'success', message);

    return true;
  }

  public warning( message: string) {
    this.spinner.hide();

    this.showToast( 'warning', message);

    console.warn( message);
  }

  public error( message: string, originalError?: any, param?: any) {
    this.spinner.hide();

    this.showToast( 'error', message, param);

    console.error( originalError || message);

    return false;
  }

  private showToast( type: ToastType, message: string, param?: any) {
    const toastFunc: Function = toastr[type].bind( toastr);

    if (param) {
      toastFunc(
        null,
        this.translate.instant(message) + param,
        { positionClass: 'toast-top-center' }
      );
    } else {
      toastFunc(
        null,
        this.translate.instant(message),
        { positionClass: 'toast-top-center' }
      );
    }
  }
}
